var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProwessIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-786 -1590)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(786 1590)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(838 1608)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1468.709 1795.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-678 -201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.656,18.184a5.325,5.325,0,0,0,5.453-5.308,5.408,5.408,0,1,0-5.453,5.308Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.531,35.263,38.682,23.821a4.539,4.539,0,0,0-2.455-2.709,16.307,16.307,0,0,0-12.95-.028,4.56,4.56,0,0,0-2.564,2.757l-.176.524A3.5,3.5,0,0,0,18.876,29.3L16.87,35.263a1.954,1.954,0,1,0,3.7,1.246l1.842-5.473a3.479,3.479,0,0,0,.541-.122v29.16a2.558,2.558,0,0,0,1,2.032c.02.017.042.032.062.048A3.036,3.036,0,0,0,28.84,59.8l.414-16.449a.449.449,0,0,1,.9,0l.13,5.153a3.5,3.5,0,0,0,.088,3.485l.2,7.811a3.036,3.036,0,0,0,4.823,2.355.552.552,0,0,0,.062-.046,2.561,2.561,0,0,0,1-2.032V51.8a3.493,3.493,0,0,0,0-3.265V29.427l2.383,7.083a1.957,1.957,0,0,0,1.964,1.329,2.01,2.01,0,0,0,.511-.1A1.956,1.956,0,0,0,42.531,35.263ZM22.958,29.481l-.022.011a2.139,2.139,0,0,1-1.02.255,2.17,2.17,0,1,1,1.042-.266ZM33.2,23.089a2.17,2.17,0,1,1-2.171,2.169A2.171,2.171,0,0,1,33.2,23.089Zm.155,29.25a2.17,2.17,0,1,1,2.171-2.171A2.171,2.171,0,0,1,33.351,52.339Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.853,42.771l-1.052.9-2.084-2.448A23.561,23.561,0,1,0,20.8,46.542v-3.98a19.921,19.921,0,1,1,17.811.137v3.955a23.424,23.424,0,0,0,4.763-2.582l2.086,2.446-1.052.9,7.533,8.845,5.774-4.265Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProwessIcon4);
export default __webpack_public_path__ + "static/media/prowess-icon4.e3406ac497bbe6d999ea981c1582a04c.svg";
export { ForwardRef as ReactComponent };